import { render, staticRenderFns } from "./DeletePromo.vue?vue&type=template&id=7c0703aa&scoped=true&"
import script from "./DeletePromo.vue?vue&type=script&lang=js&"
export * from "./DeletePromo.vue?vue&type=script&lang=js&"
import style0 from "./DeletePromo.vue?vue&type=style&index=0&id=7c0703aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0703aa",
  null
  
)

export default component.exports